import React from "react";

const Loading = ({ children, isLoading }) => {
  if (!isLoading) {
    return children;
  }

  return <div>Loading</div>;
};

export default Loading;
